import moment from 'moment';
import {Mechanics} from '@/views/timeline/services/mechanics';
import {CALENDER_UTILS_INSTANCE} from '@/views/calendar/calendar.utils';
import {MechanicBookingColors, MechanicBookingType} from '@/views/timeline/services/booking.types';

let uniqueId = 10000;

function defineColor(duration: moment.Duration): string {

    let color: MechanicBookingColors = MechanicBookingColors.red;
    if (duration.asMilliseconds() > 0) {
        if (duration.hours() > 1) {
            color = MechanicBookingColors.green;
        } else {
            color = MechanicBookingColors.orange;
        }
    }
    return color;
}


const STATIC_MECHANIC_BOOKINGS: MechanicBookingType[] = [];

for (const mechanic of Mechanics) {
    const mechanicId = mechanic.id;

    for (let i = -99; i < 99; i++) {

        const anyMoment = moment().day(i).hours(0).minutes(0).seconds(0);

        const isSaturday = anyMoment.isoWeekday() === 6;
        const isSunday = anyMoment.isoWeekday() === 7;
        if (isSaturday || isSunday) {
            continue;
        }

        const schedules = CALENDER_UTILS_INSTANCE.generateDummyData(anyMoment.toDate());
        const timeLeftInMillis = CALENDER_UTILS_INSTANCE.getTimeLeft(schedules);
        const duration = moment.duration(timeLeftInMillis);

        const newDataItem: MechanicBookingType = {
            id: ++uniqueId,
            color: defineColor(duration),
            start: anyMoment.hours(2).minutes(0).seconds(0).toDate(),
            end: anyMoment.hours(22).minutes(0).seconds(0).toDate(),
            mechanicId: mechanicId || '',
            mechanicRestAvailability: duration,
            schedules
        };

        STATIC_MECHANIC_BOOKINGS.push(newDataItem);
    }
}


export {STATIC_MECHANIC_BOOKINGS};
